// import { Injectable } from "@angular/core";
// import {
//   ActivatedRouteSnapshot,
//   Router,
//   RouterStateSnapshot,
// } from "@angular/router";
// import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";

// @Injectable({
//   providedIn: "root",
// })
// export class AuthGuard extends KeycloakAuthGuard {
//   constructor(
//     protected readonly router: Router,
//     protected readonly keycloak: KeycloakService
//   ) {
//     super(router, keycloak);
//   }

//   public async isAccessAllowed(
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot
// ): Promise<boolean> {

//   // User not authenticated
//   if (!this.authenticated) {

//     const firstLoginDone =
//       sessionStorage.getItem("firstLoginDone") === "true";

//     // FIRST LOGIN → always go to /products
//     const redirectUrl = firstLoginDone
//       ? window.location.origin + state.url
//       : window.location.origin + "/products";

//     // IMPORTANT:
//     // save BEFORE redirecting to keycloak
//     if (!firstLoginDone) {
//       sessionStorage.setItem("firstLoginDone", "true");
//     }

//     await this.keycloak.login({
//       redirectUri: redirectUrl,
//     });

//     return false;
//   }

//   // Refresh token
//   try {
//     await this.keycloak.updateToken(30);
//   } catch (err) {

//     console.error("Token refresh failed", err);

//     await this.keycloak.login({
//       redirectUri: window.location.origin + state.url,
//     });

//     return false;
//   }

//   // Role check
//   const requiredRoles = route.data.roles;

//   if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
//     return true;
//   }

//   return requiredRoles.every((role) => this.roles.includes(role));
// }

//   private decodeToken(token: string): any {
//     const payload = token.split(".")[1];
//     const decodedPayload = atob(payload);
//     return JSON.parse(decodedPayload);
//   }
// }


import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';

import {
  KeycloakAuthGuard,
  KeycloakService
} from 'keycloak-angular';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard
  extends KeycloakAuthGuard
  implements CanActivateChild {

  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  /**
   * Protect child routes.
   *
   * Delegate to the inherited canActivate() method so
   * KeycloakAuthGuard initializes authentication and roles
   * before calling isAccessAllowed().
   */
 public canActivateChild(
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> {
  return this.canActivate(childRoute, state);
}

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    if (!this.authenticated) {
      const redirectUri =
        window.location.origin + state.url;

      await this.keycloak.login({ redirectUri });

      return false;
    }

    try {
      // Refresh if the access token expires within 30 seconds.
      await this.keycloak.updateToken(30);
    } catch (error) {
      console.error('Token refresh failed:', error);

      this.keycloak.clearToken();

      const redirectUri =
        window.location.origin + state.url;

      await this.keycloak.login({ redirectUri });

      return false;
    }

    // Check the roles required by the route.
    const requiredRoles = route.data['roles'] as
      string[] | undefined;

    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    return requiredRoles.every(
      role => this.roles.includes(role)
    );
  }
}